var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"area-search-article-card-list-container"},_vm._l((_vm.articles),function(article){return _c('article-card',{key:article.article_id,attrs:{"article":article,"link-to":_vm.linkTo}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }